import { render, staticRenderFns } from "./system.vue?vue&type=template&id=6f65811e&scoped=true"
import script from "./system.vue?vue&type=script&lang=ts"
export * from "./system.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f65811e",
  null
  
)

export default component.exports